module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-thank-you",
    attrs: {
      "id": "top"
    }
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading && _vm.props) ? _c('div', [_c('VueTrigger', {
    attrs: {
      "function1": _vm.navScrolled,
      "function2": _vm.notScrolled
    }
  }), _c('div', {
    staticClass: "pages-treatments__header"
  }), _c('div', {
    staticClass: "thank-you"
  }, [_c('div', {
    staticClass: "custom-home-form__container"
  }, [_c('h2', [_vm._v("Thank You")]), _c('div', {
    staticClass: "box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d8c18e5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 600
// module chunks = 1